import React, { Component } from "react"
import PropTypes from "prop-types"

import ReconnectButton from "./reconnect_button"

export default class DisconnectedApplet extends Component {
  render() {
    return (
      <ReconnectButton
        mainService={this.props.mainService}
        services={this.props.services}
        onConnectClick={this.props.onConnectClick}
        connectClicked={this.props.connectClicked}
        disconnectClicked={this.props.disconnectClicked}
        ctaCopy="Reconnect"
        knobBgColorForDarkBrands={this.props.knobBgColorForDarkBrands}
        programmable={this.props.programmable}
        connected={this.props.appletConnected}
        animation={this.props.animation}
        updateAnimationCol={this.props.updateAnimationCol}
        connectButtonMaxFontSize={this.props.connectButtonMaxFontSize}
        showKnob
      />
    )
  }
}

DisconnectedApplet.propTypes = {
  appletConnected: PropTypes.bool,
  mainService: PropTypes.object.isRequired,
  services: PropTypes.array.isRequired,
  applet: PropTypes.object.isRequired,
  programmable: PropTypes.bool,
  onConnectClick: PropTypes.func.isRequired,
  connectClicked: PropTypes.bool.isRequired,
  disconnectClicked: PropTypes.bool.isRequired,
  animation: PropTypes.object.isRequired,
  updateAnimationCol: PropTypes.func.isRequired,
  connectButtonMaxFontSize: PropTypes.number,
  knobBgColorForDarkBrands: PropTypes.bool,
}
